import { ISchedulingValues } from './types';

// eslint-disable-next-line import/prefer-default-export
export function hasSelectedNewProvider(values: ISchedulingValues): boolean {
  const openingProviderId = values.opening?.provider?.id;
  const queryProviderId = values.queryProvider?.id;
  return (
    openingProviderId != null && queryProviderId != null && openingProviderId !== queryProviderId
  );
}

const CORRECTABLE_ERROR_KEYS = [
  'contactPhone',
  'patientCoverage.insurancePhone',
  'patientCoverage.postalCode',
  'patientCoverage.ssn',
];

export function isCorrectableSubmitFailure(submitErrors: Record<string, any>): boolean {
  return Object.keys(submitErrors).every((errorKey) => CORRECTABLE_ERROR_KEYS.includes(errorKey));
}
